import {createSlice, PayloadAction} from "@reduxjs/toolkit";



export interface IOrganizationSlice {
  adminOrganizationTotal: {
    totalLiense: number;
    totalUser: number;
  }
}

const initialState: IOrganizationSlice = {
    adminOrganizationTotal: {
        totalLiense: 0,
        totalUser: 0
    },

};

export const organizationSlice = createSlice({
  name: "organization",
  initialState,
  reducers: {
    setAdminOrganizationTotal: (state, action: PayloadAction<{ totalLiense: number; totalUser: number }>) => {
      state.adminOrganizationTotal = action.payload;
    },  
      
  },
});

export const { setAdminOrganizationTotal } = organizationSlice.actions;
export default organizationSlice.reducer;
